const setInputModal = modal => ({
  type: "SET_INPUT_MODAL",
  modal,
});

export default setInputModal;
